import React from 'react';

import {
  makeStyles,
  Snackbar,
  SnackbarProps,
  Typography
} from '@material-ui/core';
import { Alert, AlertTitle } from '@material-ui/lab';
import ErrorIcon from '@material-ui/icons/Error';
import DoneIcon from '@material-ui/icons/Done';
import { SnackbarStatus } from 'store/slices/snackbar';

interface NewSnackbarProps {
  show: boolean;
  title?: string;
  message: string | null;
  status?: SnackbarStatus | null;
  autoHideDurationInMs?: number;
  onClose: SnackbarProps['onClose'];
}

const useStyles = makeStyles(
  theme => ({
    snackbar: {
      position: 'absolute',
      top: 193
    },
    alert: {
      padding: theme.spacing(1),
      backgroundColor: theme.palette.aegis.semantic.background.white,
      boxShadow: '0px 2px 2px 0px rgba(0, 0, 0, 0.15)'
    },
    alertIcon: {
      marginRight: theme.spacing(1),
      padding: 0,
      fontSize: theme.spacing(3)
    },
    alertMessage: {
      display: 'flex',
      alignItems: 'center',
      padding: 0
    }
  }),
  { name: 'NewSnackbar' }
);

export default function NewSnackbar({
  show,
  title,
  message,
  status,
  autoHideDurationInMs,
  onClose
}: NewSnackbarProps) {
  const classes = useStyles();

  return (
    <Snackbar
      open={show}
      autoHideDuration={autoHideDurationInMs}
      anchorOrigin={{ horizontal: 'center', vertical: 'top' }}
      className={classes.snackbar}
      onClose={onClose}
    >
      <Alert
        data-testid="newSnackbar"
        severity={status ?? SnackbarStatus.Info}
        iconMapping={{
          success: <DoneIcon fontSize="inherit" />,
          error: <ErrorIcon fontSize="inherit" />,
          warning: <DoneIcon fontSize="inherit" />,
          info: <DoneIcon fontSize="inherit" />
        }}
        className={classes.alert}
        classes={{ icon: classes.alertIcon, message: classes.alertMessage }}
      >
        {!title ? null : (
          <AlertTitle>
            <Typography variant="h3" component="div">
              {title}
            </Typography>
          </AlertTitle>
        )}
        <Typography>{message}</Typography>
      </Alert>
    </Snackbar>
  );
}
